import React from 'react';
import PropTypes from 'prop-types';
import i18N from '@arreeba/ristoranti-frontend-lib/lib/helpers/i18n';
import Cart from '@arreeba/ristoranti-lib/lib/cart';

const CartRow = (props) => {
  const price = props.modifiers.length === 0 ?
    Cart.itemPrice(props) * props.quantity :
    Cart.itemPrice(props);
  return (
    <div className="cartRow" data-cartId={props.cart_id}>
      <div className="cartRow__quantity">{`${props.quantity} ×`}</div>
      <div className="cartRow__description">
        <h4 className="cartRow__name">{props.name}</h4>
        <div className="cartRow__modifiers">
          {props.modifiers.map(mod => (
            mod.items.map(item => (
              <p className="cartRow__modifier">+ {item.name}</p>))
          ))}
        </div>
      </div>
      <div className="cartRow__price">{i18N.formatPrice(price)}</div>
      {props.onRemove &&
        <button
          className="cartRow__remove"
          onClick={() => props.onRemove(props)}
        >
          <i className="bi_editorial-trash-l" />
        </button>
      }
      {!props.onRemove &&
        <span className="cartRow__remove"></span>
      }
    </div>
  );
};

const CartRowPropTypes = {
  cart_id: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.number,
  modifiers: PropTypes.array,
  onRemove: PropTypes.func,
};

CartRow.propTypes = CartRowPropTypes;

export { CartRow, CartRowPropTypes };



// WEBPACK FOOTER //
// ./src/components/cart/cart-row.js